<script lang="ts">
  interface Props {
    activeTab: string
    onTabChange: (tab: string) => void
  }
  
  let { activeTab, onTabChange }: Props = $props()
  
  const tabs = [
    { id: 'general', label: '일반', icon: '⚙️' },
    { id: 'subscription', label: '구독', icon: '⭐' },
    { id: 'api', label: '맞춤법 설정', icon: '🔌' },
    { id: 'ai', label: 'AI 모델 설정', icon: '🤖' },
    { id: 'appearance', label: '모양', icon: '🎨' },
    { id: 'shortcuts', label: '단축키', icon: '⌨️' },
  ]
</script>

<aside class="settings-sidebar">
  <nav class="settings-nav">
    {#each tabs as tab}
      <button
        class="nav-item"
        class:active={activeTab === tab.id}
        onclick={() => onTabChange(tab.id)}
      >
        <span class="nav-icon">{tab.icon}</span>
        <span class="nav-label">{tab.label}</span>
      </button>
    {/each}
  </nav>
</aside>

<style>
  .settings-sidebar {
    width: 180px;
    background: var(--bg-tertiary);
    border-right: 1px solid var(--border-primary);
    padding: 16px 12px;
  }
  
  .settings-nav {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  
  .nav-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 10px;
    background: transparent;
    border: none;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    color: var(--text-secondary);
    cursor: pointer;
    transition: all 0.15s;
    text-align: left;
    width: 100%;
  }
  
  .nav-item:hover {
    background: var(--bg-primary);
    color: var(--text-primary);
  }
  
  .nav-item.active {
    background: var(--bg-primary);
    color: var(--accent-primary);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }
  
  .nav-icon {
    font-size: 16px;
    width: 20px;
    text-align: center;
  }
  
  .nav-label {
    flex: 1;
  }
  
  /* Dark mode handled by CSS variables */
</style>